import { useEffect, useState } from "react";
import { styled as muiStyled } from "@mui/material/styles";

import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";
import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import Button from "src/components/core/Button";
import Checkbox from "src/components/core/Checkbox";

import font from "src/styles/font";
import { findAllSuggestDesc } from "src/api/quotationDraft";

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 32,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    paddingBottom: 0,
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
}));

const SuggestConditionDialog = ({ descData = "", onClose, onSubmit }) => {
  const [editText, setEditText] = useState("");
  const [suggestDescList, setSuggestDescList] = useState([]);

  const fetchSuggestDesc = async () => {
    try {
      const { data } = await findAllSuggestDesc({ type: "promocode" });

      if (!!data) {
        setSuggestDescList(
          data?.length > 0
            ? data.map((item) => ({
                ...item,
                isSelect: false,
              }))
            : []
        );
      }
    } catch (err) {
      console.error("err", err);
    }
  };

  useEffect(() => {
    let removeList = descData.split("</ul>")[0];
    setEditText(removeList);

    fetchSuggestDesc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDescText = async () => {
    let text = editText;
    suggestDescList
      .filter((item) => item.isSelect === true)
      // eslint-disable-next-line array-callback-return
      .map((selected, i) => {
        if (text === "") text = `<ul><li>${selected?.description_text}</li>`;
        else text = `${text}<li>${selected?.description_text}</li>`;
      });
    text = `${text}</ul>`;
    // console.log('----', text);
    await onSubmit(text);
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 740,
          },
        },
      }}
    >
      <DialogTitle sx={{ p: 3, textAlign: "center" }}>
        รายละเอียดการใช่ส่วนลด
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            borderRadius: "50%",
            border: "1px solid var(--lightgrey-color)",
            position: "absolute",
            right: 16,
            top: 16,
            color: "var(--primary-color)",
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          px: 5,
          width: "100%",
          position: "relative",
          "& .MuiBox-root": {
            // maxWidth: "530px",
            mx: "auto",
          },
        }}
      >
        <Box>
          <FormControl sx={{ width: "100%" }}>
            <FormLabel
              id="suggest-product-checkbox-group-label"
              sx={{
                fontSize: font.size.md,
                fontWeight: 400,
                color: "var(--secondary-color)",
                mb: 1.5,
                "&.Mui-focused": {
                  color: "var(--secondary-color)",
                },
              }}
            >
              รายละเอียดสินค้า
            </FormLabel>

            <FormGroup
              row
              aria-labelledby="suggest-product-checkbox-group-label"
              name="suggest-product-checkbox-group"
              sx={{
                ml: "-10px",
                width: "calc(100% + 10px)",
                fontSize: font.size.sm,
                color: "var(--secondary-color)",
                "& .MuiFormControlLabel-root": {
                  m: 0,
                  mb: 1,
                  alignItems: "flex-start",
                  "&.MuiRadio-root": {
                    width: "auto",
                  },
                  "& .MuiFormControlLabel-label": {
                    pt: 1,
                  },
                  ":last-child": {
                    mb: 0,
                  },
                },
              }}
            >
              {/* // ! map item */}
              {suggestDescList.map((item, index) => (
                <FormControlLabel
                  key={`suggest-desc-${index}`}
                  label={`${item?.description_text}`}
                  sx={{
                    width: "100%",
                  }}
                  control={
                    <Checkbox
                      sx={{
                        p: 1,
                        color: "var(--primary-color)",
                        "&.Mui-checked": {
                          color: "var(--primary-color)",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 24,
                        },
                      }}
                      value={item?.description_text}
                      checked={item?.isSelect}
                      onChange={(e) => {
                        // if (e.target.checked) {
                        //   setTextDesc((prev) => prev === "" ? `${e.target.value}` : `${prev}\n${e.target.value}`);
                        // }
                        setSuggestDescList((prev) => {
                          return prev.map((val) => {
                            if (item._id === val._id) {
                              val.isSelect = e.target.checked;
                            }
                            return val;
                          });
                        });
                      }}
                      // disabled={editText?.length >= 400}
                    />
                  }
                />
              ))}
            </FormGroup>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 4 }}>
        <Button
          variant="contained"
          size="large"
          onClick={() => getDescText()}
          sx={{ minWidth: 350, borderRadius: 4, py: 1.5 }}
        >
          ใช้รายละเอียดแนะนำ
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuggestConditionDialog;
